import { render } from "./AspectRatio.vue?vue&type=template&id=7968ec34"
import script from "./AspectRatio.vue?vue&type=script&lang=js"
export * from "./AspectRatio.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent-2\\_work\\118\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__